import React from 'react';
import cmsUtils from '../../utils/cmsUtils';
import utils from '../../../utils';
import { YoutubeNew } from "cms/items/youtubeNew/view";
import { SearchBar } from 'layout/topHeader/searchBar';

export function VideoPanel(props) {
  const item = props.item;
  const cmsOption = props.cmsOption || {};

  //console.log('item', item);

  const heightSet = cmsUtils.payload(item, 'HeightSet') || 'standard';
  const videoCode = cmsUtils.payload(item, 'YoutubeCode');
  const playerId = 'ytBanner-' + (item.itemId).substr(0, 8);

  const posterFrameUrl = cmsUtils.payload(item, "PosterFrameUrl", null);

  const video = {
    heightSet: heightSet,
    videoLinkOrId: videoCode,
    playerId: playerId
  }

  //const enableYoutube = env.isProd;
  const canPlayVideo = () => utils.css.screenWidth() >= 0

  const cssClass = utils.classNames('cms_item', 'youtubePanel', 'James', item.cssClass || item.anchorName || '');

  //console.log(window.innerWidth, canPlayVideo())

  return (
    <div className={cssClass} data-cms-item-id={cmsOption.isCmsEdit && item.itemId} id={item.anchorName}>
      <YoutubeNew
        video={video}
        canPlayVideo={canPlayVideo}
        posterImageUrl={utils.site.resourcePath(posterFrameUrl)}
      />
      <div className='bottom-search-container'>
        <h3>Be surprised at what you can find in Whyalla!</h3>
        <SearchBar onCloseMenu={props.onCloseMenu} />
      </div>
    </div>
  );
}
